/* angular:styles/component:css;1c82d5f2ffb885a5fafc0b8e26420f85ef8fc3058728327958b1d5e8dd071c7e;C:\RDF\github-dev\fusion-web\src\app\components\shared\user-avatar\user-avatar.component.ts */
.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 0.72em;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  user-select: none;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}
.user-avatar--lg {
  width: 56px;
  height: 56px;
  font-size: 1.3em;
  letter-spacing: 0.05em;
}
/*# sourceMappingURL=user-avatar.component.css.map */
